<template>
  <div class="recomendaciones-ia">
    <h3 class="text-2xl font-bold text-gray-800 mb-6">🤖 Recomendaciones Inteligentes de IA</h3>
    
    <div class="space-y-6">
      <div
        v-for="(rec, index) in recomendaciones"
        :key="index"
        class="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300"
      >
        <!-- Header -->
        <div :class="[
          'p-6 border-b',
          rec.prioridad === 'ALTA' ? 'bg-gradient-to-r from-red-500 to-pink-500 text-white' :
          rec.prioridad === 'MEDIA' ? 'bg-gradient-to-r from-yellow-500 to-orange-500 text-white' :
          'bg-gradient-to-r from-blue-500 to-indigo-500 text-white'
        ]">
          <div class="flex items-start justify-between">
            <div class="flex-1">
              <div class="flex items-center gap-3 mb-2">
                <span class="text-3xl">{{ getCategoryIcon(rec.categoria) }}</span>
                <div>
                  <span class="px-3 py-1 bg-white bg-opacity-20 rounded-full text-xs font-bold">
                    {{ rec.categoria }}
                  </span>
                </div>
              </div>
              <h4 class="text-2xl font-black mb-2">{{ rec.titulo }}</h4>
              <p class="text-sm opacity-90">{{ rec.descripcion }}</p>
            </div>
            <div class="text-right">
              <div :class="[
                'px-4 py-2 rounded-xl font-bold text-sm',
                rec.prioridad === 'ALTA' ? 'bg-red-900 bg-opacity-50' :
                rec.prioridad === 'MEDIA' ? 'bg-yellow-900 bg-opacity-50' :
                'bg-blue-900 bg-opacity-50'
              ]">
                {{ rec.prioridad }}
              </div>
            </div>
          </div>
        </div>

        <!-- Content -->
        <div class="p-6">
          <!-- Acciones -->
          <div class="mb-6">
            <h5 class="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
              <span>📋</span> Plan de Acción
            </h5>
            <ul class="space-y-2">
              <li
                v-for="(accion, i) in rec.acciones"
                :key="i"
                class="flex items-start gap-3 p-3 bg-blue-50 rounded-xl hover:bg-blue-100 transition-colors"
              >
                <span class="flex-shrink-0 w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                  {{ i + 1 }}
                </span>
                <span class="text-gray-700">{{ accion }}</span>
              </li>
            </ul>
          </div>

          <!-- Métricas -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border border-green-200">
              <div class="text-xs font-semibold text-green-700 mb-1">💰 Impacto Estimado</div>
              <div class="text-lg font-bold text-green-900">{{ rec.impacto_estimado }}</div>
            </div>
            <div class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-4 border border-purple-200">
              <div class="text-xs font-semibold text-purple-700 mb-1">⏱️ Tiempo</div>
              <div class="text-lg font-bold text-purple-900">{{ rec.tiempo_implementacion }}</div>
            </div>
            <div class="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl p-4 border border-yellow-200">
              <div class="text-xs font-semibold text-yellow-700 mb-1">📈 ROI Estimado</div>
              <div class="text-lg font-bold text-yellow-900">{{ rec.roi_estimado }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecomendacionesIA',
  props: {
    recomendaciones: {
      type: Array,
      required: true
    }
  },
  methods: {
    getCategoryIcon(categoria) {
      const icons = {
        'VENTAS': '💰',
        'PRODUCCION': '🏭',
        'CLIENTES': '👥',
        'PRODUCTOS': '📦',
        'FINANZAS': '💵'
      }
      return icons[categoria] || '📊'
    }
  }
}
</script>
